import React, { useState, useEffect, useCallback } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import { useDropzone } from "react-dropzone";

let myModal = {};

export default function DropzoneModal(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg,image/png",
    maxFiles: 1,
    multiple: false,
    getFilesFromEvent: (event) => myCustomFileGetter(event),
  });

  async function myCustomFileGetter(event) {
    const files = [];
    const fileList = event.dataTransfer
      ? event.dataTransfer.files
      : event.target.files;
    for (var i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);
      files.push(file);
    }

    console.log("Files :", files);
    if (files.length > 0) {
      upload_image(files[0]);
    }
    return files;
  }

  async function upload_image(file_data) {
    console.log("file_data :", file_data);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        type: props.from,
      },
      post: {
        image: file_data,
      },
    };
    console.log("pass data :", pass_data);
    let response = await api("/brand/upload_image", pass_data, false, true); // bolb , image
    console.log("/brand/upload_image response :", response);
    if (response.status_code == 201) {
      if (response.response.hasOwnProperty("id")) {
        let item = close_data;
        item.action = "save";
        item.value = response.response.id;
        console.log("Close data : ", item);
        SetCloseData(item);
        myModal.hide();
      }
    }
  }

  useEffect(() => {
    console.log("DropzoneModal On mount :", props);
    let myModal1 = document.getElementById("ModalDropzone");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("hide event close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.is_open) {
      console.log("DropzoneModal On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ModalDropzone"),
        {}
      );
      myModal.show();
    }
  }, [props.is_open]);

  return (
    <div
      className="modal fade"
      id="ModalDropzone"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              DropZone
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <div className="d-flex">
                <label className="form-label">Select Image</label>
              </div>
              <section className="">
                <div
                  {...getRootProps({
                    className:
                      "dropzone  h-50 border p-3 justify-content-center d-flex",
                  })}
                >
                  <input {...getInputProps()} />
                  <p className="mb-0">Drag & Drop logo</p>
                </div>
              </section>
              {/* <div className="mt-2 d-flex">
                <button className="btn btn-blue-outline me-2 btn-sm">
                  Upload
                </button>
              </div> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {/* <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                console.log("Save");
              }}
            >
              Save
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
